import { create } from 'zustand'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'

export type IssueTypePropertiesT = {
  issueTypeId: number | string
  statusGroupProperty: PopoverProperty | null
  statuses: PopoverProperty[]
  allFiltersProperties: PopoverProperty[]
  labelGroupsProperties: PopoverProperty[]
}

type IssuesPropertiesStoreT = {
  allProperties: Array<IssueTypePropertiesT>
  setProperties: (properties: IssueTypePropertiesT[]) => void
}

export const usePropertiesByIssueTypeStore = create<IssuesPropertiesStoreT>(set => ({
  allProperties: [],
  setProperties: allProperties => set({ allProperties: allProperties }),
}))

/*ℹ️ Helper foo to get properties from the store */
type KeyT = keyof Omit<IssueTypePropertiesT, 'issueTypeId'>

export default function useGetCurrIssueTProps<K extends KeyT>(key: K): IssueTypePropertiesT[K] {
  const issueTypeId2 = useProjectStageStore(state => state.currIssueType)?.id
  const props =
    usePropertiesByIssueTypeStore(state => state.allProperties)?.find(
      p => p.issueTypeId == issueTypeId2,
    )?.[key] ?? []

  return props as IssueTypePropertiesT[K]
}
